import useRoleMutation from "~/pages/RegistryOfRole/hooks/useRoleMutation";

export default function useUpdateRoleStatus() {
  return useRoleMutation(
    "/internal-api/auth/access/role/activity",
    "PUT",
    "getRole",
  );
}
